import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useMask } from '@react-input/mask';
import { UserService } from "../../../services/usuarios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import UserContext from "../../../context";

const RegistroForm: React.FC = () => {
    
  const inputRef = useMask({ mask: '(__) _ ____-____', replacement: '_' });
  const inputRefCpf = useMask({ mask: '___.___.___-__', replacement: '_' });

  const [usertype, setusertype] = useState("");
  const [crm, setCrm] = useState("");
  const [nome, setNome] = useState("");
  const [sobrenome, setSobrenome] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [cpf, setCpf] = useState("");
  const [birthdate, setbirthdate] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [acceptterms, setacceptterms] = useState(false);
  const [acceptprivacy, setacceptprivacy] = useState(false);

  
  const stylesForm: React.CSSProperties = {
      //maxWidth: 600, 
      padding: 0,
      maxHeight: "80vh",
      overflowY: "auto"
  };

  const [hasPasswordEquals, setHasPasswordEquals] = useState<boolean>(false);

  useEffect(()=>{
      if(password !== confirmPassword) setHasPasswordEquals(false)
      else setHasPasswordEquals(true)
  },[password, confirmPassword]);

  const validatePassword = (password: string) => {
      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumber = /[0-9]/.test(password);
      const hasSpecialChar = /[@$!%*#?&]/.test(password);
      const isMinLength = password.length >= 8;

      if (!hasUpperCase) {
        return "A senha deve conter pelo menos uma letra maiúscula.";
      }
      if (!hasLowerCase) {
        return "A senha deve conter pelo menos uma letra minúscula.";
      }
      if (!hasNumber) {
        return "A senha deve conter pelo menos um número.";
      }
      if (!hasSpecialChar) {
        return "A senha deve conter pelo menos um caractere especial: @ $ ! % * # ? &";
      }
      if (!isMinLength) {
          return "A senha deve ter no mínimo 8 digítos";
      }
      return null;
  };

  const [passwordHelperTextError, setPasswordHelperTextError] = useState<string | null>(null);

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newPassword = e.target.value;
      setPassword(newPassword);
  
      // Atualiza o erro de validação da senha
      const error = validatePassword(newPassword);
      setPasswordHelperTextError(error);
  };

  const [isError, setIsError] = useState(false);
  const [helperText, setHelperText] = useState(" ");

  const validateEmail = (value: string) => {
    // Expressão regular simples para validar o formato de e-mail
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setIsError(true);
      setHelperText("E-mail inválido. Por favor, insira um e-mail válido.");
    } else if (value !== confirmEmail && confirmEmail) {
      setIsError(true);
      setHelperText("Os e-mails não coincidem.");
    } else {
      setIsError(false);
      setHelperText(" ");
    }
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setEmail(value);
    validateEmail(value);
  };
  
  const handleConfirmEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setConfirmEmail(value);
    if (value !== email) {
      setIsError(true);
      setHelperText("Os e-mails não coincidem.");
    } else {
      setIsError(false);
      setHelperText(" ");
    }
  };

  function extractNumbers(input: string): string {
    return input.replace(/\D/g, "");
  }
  
  const instance = new UserService();
  
  const ctx = useContext(UserContext);
  
  const navigate = useNavigate();

  const getProfile = () => {
    instance.getProfile()
    .then(data => {

        if(ctx?.setUser)
            ctx?.setUser(data);

        window.location.href = "/beneficiario";
    })
    .catch(error => console.log('error get profile', error))
  }

  const handleSubmit = async (event: { preventDefault: () => void; }) => {

    event.preventDefault();

    const payload = {
      usertype,
      crm,
      cpf: extractNumbers(cpf),
      nome,
      sobrenome,
      email,
      birthdate,
      phone,
      password,
      acceptterms,
      acceptprivacy
    }

    instance.signUp(payload)
    .then(res => {
      toast.success("Cadastrado com sucesso!");
      console.log('res', res)
      if(res.access_token)
      {  
        sessionStorage.setItem('token', res.access_token);
        getProfile();
      }
    
    })
    .catch(error => {
      toast.error("Erro ao cadastrar usuário, por favor, contatar desenvolvedor!")
    })
  }
  return (
    <Box sx={stylesForm} component="form" onSubmit={handleSubmit}>
      <Typography variant="h5" color="warning" gutterBottom>
        Faça seu cadastro:
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Se você nunca acessou nossos serviços, basta preencher os campos abaixo, submeter seu cadastro e acessar todas as facilidades que o Minha Innova tem para você.
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, alignItems : "flex-start" }}>

        <FormControl variant="standard" margin="normal" sx={{ width: "14em"}}>
          <InputLabel>Sou:</InputLabel>
          <Select
            value={usertype}
            onChange={(e) => setusertype(e.target.value as string)}
          >
            <MenuItem value="CLIENTE">Cliente</MenuItem>
            <MenuItem value="COOPERADO">Médico Cooperado</MenuItem>
          </Select>
        </FormControl>
        {
          usertype === "COOPERADO" ?
            <TextField
              size="small"
              label="CRM"
              required
              type="number"
              variant="outlined"
              margin="normal"
              value={crm}
              onChange={(e) => setCrm(e.target.value)}
              helperText="[Apenas números]"
            />
          : <></>
        }
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <TextField
     
            size="small"
            fullWidth
            required
            label="Primeiro Nome"
            variant="outlined"
            margin="normal"
            
            value={nome}
            onChange={e => setNome(e.target.value)}
        />
        <TextField
       
            size="small"
            fullWidth
            required
            label="Último Nome"
            variant="outlined"
            margin="normal"
            
            value={sobrenome}
            onChange={e => setSobrenome(e.target.value)}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <TextField
            error={isError}
            helperText={helperText}
            size="small"
            fullWidth
            required
            label="E-mail"
            variant="outlined"
            margin="normal"
            type="email"
            value={email}
            onChange={handleEmailChange}
        />
        <TextField
            //error={isError}
            //helperText={helperText}
            size="small"
            fullWidth
            required
            label="Confirme seu E-mail"
            variant="outlined"
            margin="normal"
            type="email"
            value={confirmEmail}
            onChange={handleConfirmEmailChange}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 2, alignItems: "flex-start" }}>

        <TextField
            size="small"
            fullWidth
            inputRef={inputRefCpf}
            label="CPF"
            required
            variant="outlined"
            margin="normal"
            value={cpf}
            onChange={(e) => setCpf(e.target.value)}
            helperText="[Apenas números]"
        />
        <TextField
            size="small"
            fullWidth
            label="Data de Nascimento"
            variant="outlined"
            required
            margin="normal"
            type="date"
            value={birthdate}
            onChange={(e) => setbirthdate(e.target.value)}
            InputLabelProps={{
            shrink: true,
            }}
        />
        <TextField
            size="small"
            fullWidth
            inputRef={inputRef}
            required
            label="Telefone"
            variant="outlined"
            margin="normal"
            value={phone}
            onChange={v => setPhone(v.target.value)}
            helperText="[Apenas números]"
        />
 
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <TextField
            size="small"
            error={passwordHelperTextError && passwordHelperTextError?.length > 0 || !hasPasswordEquals ? true : false}
            fullWidth
            label="Senha"
            variant="outlined"
            required
            margin="normal"
            type="password"
            value={password}
            helperText={passwordHelperTextError ? passwordHelperTextError : !hasPasswordEquals && confirmPassword && confirmPassword.length > 0 ? "Senha não são iguais!" : ""}
            onChange={handlePasswordChange}
        />
        <TextField
            size="small"
            error={!hasPasswordEquals && confirmPassword && confirmPassword.length > 0 ? true : false}
            helperText={!hasPasswordEquals && confirmPassword && confirmPassword.length > 0 ? "Senha não são iguais!" : ""}
            fullWidth
            label="Confirme sua Senha"
            required
            variant="outlined"
            margin="normal"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </Box>

      <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
        É recomendado que sua senha possua:
      </Typography>
      <ul style={{ paddingLeft: 16, marginTop: 0, listStyle: "none" }}>
        <li>Pelo menos uma letra maiúscula</li>
        <li>Pelo menos uma letra minúscula</li>
        <li>Pelo menos um número</li>
        <li>Pelo menos um caractere especial: @ $ ! % * # ? &</li>
      </ul>

      <FormControlLabel
        control={
          <Checkbox
            color="warning"
            checked={acceptterms}
            onChange={(e) => setacceptterms(e.target.checked)}
          />
        }
        label={
          <Typography variant="body2">
            Li e concordo com o <a className='a' href="#">Termo de Aceitação</a>.
          </Typography>
        }
      />
      <FormControlLabel
        control={
          <Checkbox
            color="warning"
            checked={acceptprivacy}
            onChange={(e) => setacceptprivacy(e.target.checked)}
          />
        }
        label={
          <Typography variant="body2">
            Estou ciente da <a className='a' href="/politicas-de-privacidade-e-lgpd">Política de Privacidade</a>.
          </Typography>
        }
      />

      <Button
        variant="contained"
        color="warning"
        type="submit"
        fullWidth
        sx={{ mt: 2 }}
        disabled={
          !acceptterms || !acceptprivacy || confirmEmail !== email || password !== confirmPassword
        }
      >
        Salvar cadastro
      </Button>
    </Box>
  );
};

export default RegistroForm;
